import { createFileRoute } from "@tanstack/react-router";
import { PageContentContainer } from "@/shared/components/PageContentContainer";
import { InterestedPoolsTab } from "./-internal/InterestedPoolsTab";

export const Route = createFileRoute("/buy/interested")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PageContentContainer>
      <InterestedPoolsTab />
    </PageContentContainer>
  );
}
